"use client";
import Hero from "@/components/nav/Hero";
import Nav from "@/components/nav/Nav";
import { tokenCheck } from "@/data/user";
import Head from "next/head";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useSession } from "next-auth/react";
import { signOut } from "next-auth/react";

import Loading from "./loading";
import { toast } from "react-hot-toast";
import { setDatadogUser, clearDatadogUser } from "@/utils/datadog";

const Home = () => {
  const router = useRouter();
  const { data, status }: any = useSession();
  const token = data?.token || null;

  useEffect(() => {
    const validateUser = async () => {
      const accessToken = token.id_token;
      const idToken = token.id_token;
      const expires_at = token?.expires_at;
      localStorage.setItem("@BLUE-access_token", accessToken);
      localStorage.setItem("@BLUE-id_token", idToken);
      localStorage.setItem("@BLUE-expires_at", JSON.stringify(expires_at));
      const { user } = await tokenCheck(idToken);
      if (user) {
        localStorage.setItem("@BLUE-user", JSON.stringify(user));

        // Set user context in Datadog RUM
        try {
          setDatadogUser({
            id: user?.id || null,
            email: user?.email || null,
            username: user?.username || null,
            firstName: user?.firstName || null,
            lastName: user?.lastName || null,
            externalUserId: user?.externalUserId || null,
            locale: user?.locale || null,
            role: user?.role || null,
            position: user?.position || null,
            status: user?.status || null,
            is_operator: user?.is_operator || null,
            tags: user?.tags || null,
            createdAt: user?.createdAt || null,
            updatedAt: user?.updatedAt || null,
            teamId: user?.TeamId || null,
          });
          console.log("User set for Datadog RUM: ", user);
        } catch (error) {
          console.error("Error setting user for Datadog RUM: ", error);
        }
        
        router.push("/cameras");
      } else {
        // Clear Datadog user context if login fails
        clearDatadogUser();
        localStorage.removeItem("@BLUE-access_token");
        localStorage.removeItem("@BLUE-id_token");
        localStorage.removeItem("@BLUE-expires_at");
        localStorage.removeItem("@BLUE-user");
        toast.error("Please Login Again");
        signOut({
          callbackUrl: "/",
        });
      }
    };
    if (token) {
      validateUser();
    }
  }, [token, status, router]);

  if (status === "loading") return <Loading />;
  return (
    <div className="w-100vw relative h-screen bg-gray-900">
      <Head>
        <title>aipx.co</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content="aipx"></meta>
        <meta property="og:title" content="aipx.co" />
        <meta name="og:description" content="aipx"></meta>
        <meta property="og:type" content="website" />
        <meta property="tags" content="incident management" />
        <meta property="og:url" content="https://aipx.co" />
        <meta property="og:image" content="" />
      </Head>
      <Nav />
      <Hero />
    </div>
  );
};

export default Home;
